import React, {Fragment} from 'react';
import Typography from "@mui/material/Typography";
import {
    Button,
    Divider,
    FormControl,
    FormControlLabel,
    List,
    ListItem,
    MenuItem,
    Paper,
    Radio,
    RadioGroup,
    TextField
} from "@mui/material";
import {makeStyles} from "@mui/styles";
import Grid from "@mui/material/Grid";
import Spinner from "../SelectRoom/Spinner";
import {useDispatch, useSelector} from "react-redux";
import {setSpaceGender} from "../../../redux/actions/transactionActions";
import {canChangeGender, getNextStep, showAlertAutoDis, isWidget, bookingActions} from "../../../utils/utils";
import {useHistory} from "react-router-dom";
import {setBookingType} from "../../../redux/actions/tripActions";


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
    },
    section1: {
        margin: theme.spacing(3, 2),
    },
    section2: {
        margin: theme.spacing(1, 0),
    },
    bookingButton: {
        width: '100%',
        borderRadius: '0',
        textAlign: 'center',
        backgroundColor: '#00b7f0',
        color: '#ffffff',
        '&:hover': {
            backgroundColor: '#11486e',
            color: '#ffffff',
        },
    },
    moreInfoButton: {
        textAlign: 'center',
        backgroundColor: 'transparent',
        borderRadius: '0',
        width: '100%'
    },
    bookingText: {
        '& span': {
            fontSize: '1.8rem',
        }
    }
}));

const SummaryContainer = () => {
    const classes = useStyles();
    const rooms = useSelector(state => state.rooms);
    const step = useSelector(state => state.step);
    const {selectedRooms} = useSelector(state => state.transactions);
    const bookingType = useSelector(state => state.bookingType);
    const totals = useSelector(state => state.totals);
        const {data: trip} = useSelector(state => state.trip);

    const bookingId = trip?.TripId;
    const atLeastOneRoom = selectedRooms.length > 0;
    const history = useHistory();
    const dispatch = useDispatch();

    const hasSelectedSpaces = (roomIndex) => selectedRooms.filter(r => r.index === roomIndex).length > 0;
    const handleGenderSelection = (selectionId, gender) => {
        dispatch(setSpaceGender(selectionId, gender));
    };

    const hasAllSpacesWithGender = selectedRooms.every(s => s.sex !== '');

    const shouldDisableGender = (roomIndex, gender, selectionId) => {
        const roomType = rooms.find(r => r.index === roomIndex);
        return !canChangeGender(selectedRooms, selectionId, roomType, gender);
    };
    const prefixUrl = isWidget()?'plugin':'booking';
    const setBooking = (e) => {
        const type = e.target.value;
        dispatch(setBookingType(type));
    };

    const handleReview = () => {
        if (!(atLeastOneRoom && hasAllSpacesWithGender)) return showAlertAutoDis({
            title: 'Review Booking',
            text: 'Please add space and select gender to continue with your booking'
        });

        const currentStep = getNextStep(step-1);
        const nextStep = getNextStep(step);
        bookingActions(
            currentStep.label,
            'Next Step',
            `${trip.TripId} - PAX: ${selectedRooms.length} - BookingType: ${bookingType}`,
            trip.locationInfo.location,
            trip.boarddate,
            parseFloat(totals.roomsAmount ?? 0).formatMoney(0))
        history.push(`/${prefixUrl}/${bookingId}${nextStep.url}`);
    };

    const handleInquiry = () => {
        history.push(`/${prefixUrl}/${bookingId}/inquiry`);
    };

    const handleWait = () => {
        history.push(`/${prefixUrl}/${bookingId}/wait-list`);
    };

    return (
        <Paper className={'summaryContainer'} elevation={3}>
			{bookingType === 'wait' ?
                <Button color={'primary'} variant={'contained'} fullWidth onClick={handleWait}>
                    Add me to Wait List
                </Button> : <Button color={'primary'} variant={'contained'} fullWidth onClick={handleReview}>
                    Next step
                </Button>
            }
            <Button color={'secondary'} variant={'contained'} fullWidth onClick={handleInquiry}>
                Please send me more info
            </Button>
            <List style={{width: '100%', paddingBottom: 0, paddingTop: 0}}>
                {!atLeastOneRoom &&
                    <ListItem alignItems={"flex-start"} style={{justifyContent: 'center', margin: 0, padding: 15}}>
                        <Typography variant="h4" align="center">
                            Select a Room
                        </Typography>
                    </ListItem>}
                {rooms && rooms.length > 0 && rooms.map((room) => hasSelectedSpaces(room.index) && (
                    <Fragment key={room.index}>
                        <ListItem className={classes.section2}>
                            <Grid container alignItems="center">
                                <Grid item xs>
                                    <Typography gutterBottom variant="h5" align="left">
                                        {/<\/?[a-z][\s\S]*>/i.test(room['title']) ?<span dangerouslySetInnerHTML={{__html: room['title']}}/>:room['title']}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Spinner mini index={room.index}/>
                                </Grid>
                            </Grid>
                        </ListItem>
                        {selectedRooms.filter(s => s.index === room.index).map((guest, index) => (
                            <ListItem className={classes.section2} key={guest.id}>
                                <Grid container alignItems="flex-end">
                                    <Grid item xs>
                                        <Typography gutterBottom variant="h5" align="left">
                                            Guest {index + 1}
                                        </Typography>
                                        {guest['singleOccupancy'] &&
                                            <Typography color="textSecondary" variant="body2">
                                                Single Occupancy
                                            </Typography>}
                                    </Grid>
                                    <Grid item sm container alignItems="flex-start">
                                        <FormControl fullWidth>
                                            <TextField
                                                select
                                                id="gender"
                                                color="default"
                                                variant="outlined"
                                                size="small"
                                                label="Gender"
                                                value={guest['sex']}
                                                SelectProps={{
                                                    MenuProps: {
                                                        autoFocus: false,
                                                        disableAutoFocusItem: true,
                                                        disableEnforceFocus: true,
                                                        disableAutoFocus: true,
                                                    },
                                                }}
                                                onChange={(e) => handleGenderSelection(guest.id, e.target.value)}
                                            >
                                                <MenuItem value="">Select</MenuItem>
                                                <MenuItem value="male"
                                                          disabled={shouldDisableGender(guest['index'], "male", guest.id)}>
                                                    Male
                                                </MenuItem>
                                                <MenuItem value="female"
                                                          disabled={shouldDisableGender(guest['index'], "female", guest.id)}>
                                                    Female
                                                </MenuItem>
                                            </TextField>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </ListItem>
                        ))}
                        <Divider variant="middle" className={'dividerFullWidth'}/>
                    </Fragment>
                ))}
                {selectedRooms && selectedRooms.length > 0 &&
                    <Fragment>
                        <ListItem className={classes.section2}>
                            <Grid container alignItems="center">
                                <Grid item xs>
                                    <Typography gutterBottom variant="h5" align="left">
                                        Total
                                    </Typography>
                                </Grid>
                                <Grid item xs>
                                    <Typography gutterBottom variant="h5" align="right">
                                        <strong>${(totals.roomsAmount).formatMoney(2)}</strong>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </ListItem>
                        <Divider variant="middle" className={'dividerFullWidth'}/>
                    </Fragment>
                }
				{!isWidget() &&
                <ListItem alignItems={"center"} style={{justifyContent: 'center', margin: 0, padding: 15}}>
                    <FormControl component="fieldset" className={'bookingOptions'}>
                        <RadioGroup aria-label="typeBooking" name="typeBooking" value={bookingType}
                                    onChange={setBooking}>
                            <FormControlLabel value="pay" control={<Radio color="default"/>} label="Pay Now"
                                              style={{fontSize: 20}}/>
                            <Typography color="textSecondary" variant="body2"
                                        style={{marginLeft: 33, fontSize: '1.3rem'}}>
                                Make an initial payment to secure your booking now
                            </Typography>
                            <FormControlLabel value="hold" control={<Radio color="default"/>}
                                              label="Complimentary hold" style={{fontSize: 20}}/>
                            <Typography color="textSecondary" variant="body2"
                                        style={{marginLeft: 33, fontSize: '1.3rem'}}>
                                Let us hold your booking for 72 hours, no questions asked
                            </Typography>
                            <FormControlLabel value="wait" control={<Radio color="default"/>} label="Trip Wait List"
                                              style={{fontSize: 20}}/>
                            <Typography color="textSecondary" variant="body2"
                                        style={{marginLeft: 33, fontSize: '1.3rem'}}>
                                I'm looking for spaces, please put my name on your Wait List.
                            </Typography>
                        </RadioGroup>
                    </FormControl>
                </ListItem>
				}
            </List>
        </Paper>
    );
};

export default SummaryContainer;
